
export const  NAVBAR_DATA_LOADING = "NAVBAR_DATA_LOADING"
export const  NAVBAR_DATA_SUCCESS = "NAVBAR_DATA_SUCCESS"
export const  NAVBAR_DATA_ERROR = "NAVBAR_DATA_ERROR"